export const MessagesDefaultTimeout = {
    Success: 6000,
    Warning: 10000,
    Error: 7000
}